import React from "react";
import { Card } from "@/components/ui/card";

// Shared visual primitives used across the Growth Center tabs.
// Intentionally light-mode, emerald-accented, no purple gradients.

export const Section = ({ title, subtitle, right, children }) => (
  <div className="mb-8">
    <div className="flex items-start justify-between gap-4 mb-4">
      <div>
        <h2 className="text-2xl font-bold tracking-tight text-slate-900">{title}</h2>
        {subtitle && <p className="text-sm text-slate-600 mt-1 max-w-2xl">{subtitle}</p>}
      </div>
      {right}
    </div>
    {children}
  </div>
);

export const Tile = ({ label, value, hint, tone = "slate" }) => {
  const toneMap = {
    slate: "text-slate-900", emerald: "text-emerald-700",
    amber: "text-amber-700", rose: "text-rose-700", indigo: "text-indigo-700",
  };
  return (
    <Card className="p-5 border border-slate-200 rounded-2xl">
      <div className="text-[11px] uppercase tracking-widest text-slate-500 font-semibold">{label}</div>
      <div className={`text-3xl font-extrabold mt-1 ${toneMap[tone]}`}>{value}</div>
      {hint && <div className="text-xs text-slate-500 mt-1">{hint}</div>}
    </Card>
  );
};

export const Chip = ({ tone = "slate", children, testId }) => {
  const map = {
    slate: "bg-slate-100 text-slate-700",
    emerald: "bg-emerald-100 text-emerald-800",
    amber: "bg-amber-100 text-amber-800",
    rose: "bg-rose-100 text-rose-800",
    indigo: "bg-indigo-100 text-indigo-800",
    sky: "bg-sky-100 text-sky-800",
  };
  return (
    <span data-testid={testId} className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold uppercase tracking-wide ${map[tone]}`}>
      {children}
    </span>
  );
};

export const impactTone = (v) => (v === "high" ? "emerald" : v === "medium" ? "amber" : "slate");
export const effortTone = (v) => (v === "low" ? "emerald" : v === "medium" ? "amber" : "rose");

export const arrayField = (val) => (Array.isArray(val) ? val.join(", ") : (val || ""));
export const parseArray = (s) => (s || "").split(",").map((v) => v.trim()).filter(Boolean);
